
import PGSHelper from "../helpers/uvHelper.js";

export default class Reserva {
    static $pgsHelper = new PGSHelper();
    constructor(type) {
        this.Tipo = type;
    }

    static rules = {
        Nombre: [(value) => !!value || "El nombre es obligatorio"],
        Tarifa: [(value) => !!value || "La tarifa es obligatoria"],
    };





    static parseAvailabilityData(data, index = 1) {
        try {
            let availability = [];
            let bahia = index;
            data = Object.entries(data[bahia]);

            data.forEach((element) => {
                let reservationData = [];
                if (element[1].Rvs) {
                    let rvsData = Object.entries(element[1].Rvs);
                    rvsData.forEach((reserva) => {
                        if (reserva[1].Pys) {
                            reserva[1].Pys.forEach((player) => {
                                reservationData.push({
                                    id: reserva[0],
                                    ...player,
                                    Notas: reserva[1].nots,
                                    Color: reserva[1].colr,
                                    FolioReserva: reserva[1].frva,
                                });
                            });
                        } else {
                            console.log(element[1]);
                        }
                    });
                    availability.push({
                        time: element[0],
                        rvsData: reservationData,
                        ...element[1],
                    });
                } else {
                    availability.push({ time: element[0], ...element[1] });
                }
            });
            return availability;
        } catch (e) {
            console.log(e);
            this.$pgsHelper.catchError(e, { action: "alert" });
        }
    }


}
